import React, { createContext, useContext, useState, ReactNode } from 'react';
import { TUserInfo } from '@utils/Interfaces'; // Nhập kiểu dữ liệu của bạn
import Helpers from '@utils/Helpers';

// DEFINE CONTEXT TYPE
interface UserContextType {
    userProfile: TUserInfo | null;
    updateUserProfile: (profile: TUserInfo) => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider = ({ children }: { children: ReactNode }) => {
    const [userProfile, setUserProfile] = useState<TUserInfo | null>(Helpers.getUserInfo());
    const updateUserProfile = (newProfile: TUserInfo) => {
        setUserProfile(newProfile);
    };

    return (
        <UserContext.Provider value={{ userProfile, updateUserProfile }}>
            { children }
        </UserContext.Provider>
    );
};

export const useUser = () => {
    const context = useContext(UserContext);
    if (context === undefined) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
};
